import api from './axios';

export const getSchools       = (params) => api.get('/schools', { params });
export const getSchoolDistricts = ()     => api.get('/schools/districts');
export const createSchool     = (data)   => api.post('/schools', data);
export const updateSchool     = (id, data) => api.put(`/schools/${id}`, data);
export const deleteSchool     = (id)     => api.delete(`/schools/${id}`);
